import { useCallback, useRef, useState } from "react";

type Props = {
  onFile: (file: File) => void;
  disabled?: boolean;
};

export function UploadZone({ onFile, disabled }: Props) {
  const [dragOver, setDragOver] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleFiles = useCallback(
    (files: FileList | null) => {
      if (!files || files.length === 0) return;
      const f = files[0];
      if (f.type !== "application/pdf" && !f.name.toLowerCase().endsWith(".pdf")) {
        alert(`Alleen PDF ondersteund (kreeg ${f.type || "onbekend type"})`);
        return;
      }
      onFile(f);
    },
    [onFile]
  );

  return (
    <div
      className={`border-2 border-dashed rounded-lg p-10 text-center transition
        ${dragOver ? "border-blue-500 bg-blue-50" : "border-gray-300 bg-white"}
        ${disabled ? "opacity-50 pointer-events-none" : "cursor-pointer hover:border-blue-400"}
      `}
      onDragOver={(e) => {
        e.preventDefault();
        setDragOver(true);
      }}
      onDragLeave={() => setDragOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDragOver(false);
        handleFiles(e.dataTransfer.files);
      }}
      onClick={() => inputRef.current?.click()}
    >
      <input
        ref={inputRef}
        type="file"
        accept="application/pdf,.pdf"
        className="hidden"
        onChange={(e) => handleFiles(e.target.files)}
      />
      <div className="text-gray-600">
        <div className="text-lg mb-2">
          {dragOver ? "Loslaten om te uploaden" : "Sleep een PDF hierheen"}
        </div>
        <div className="text-sm">of klik om te kiezen</div>
      </div>
    </div>
  );
}
